export default __webpack_public_path__ + "static/dietlabs_logo-598b8ef3ac3247d25c39e29b6b3a43c9.svg";